import React from 'react';
import { Sun, Cloud, Clock } from 'lucide-react';
import '../styles/components/Header.css';

const Header = ({ currentUser, currentDate, weather }) => {
   // Calculate time until midnight for posting deadline
   const now = new Date();
   const tomorrow = new Date(now);
   tomorrow.setDate(tomorrow.getDate() + 1);
   tomorrow.setHours(0, 0, 0, 0);

   const timeUntilMidnight = tomorrow - now;
   const hoursLeft = Math.floor(timeUntilMidnight / (1000 * 60 * 60));
   const minutesLeft = Math.floor((timeUntilMidnight % (1000 * 60 * 60)) / (1000 * 60));

   // Days until next reward (every 2 months = 60 days, currently at day 47 of streak)
   const daysUntilReward = 60 - (currentUser.streak % 60);

   return (
      <div className="header-container">
         <div className="header-left">
            <h1 className="app-title">ilyo</h1>
            <div className="weather-info">
               {weather.condition === 'sunny' ? <Sun size={12} /> : <Cloud size={12} />}
               <span>{weather.temp}°F</span>
               <span>•</span>
               <span>{currentDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</span>
            </div>
         </div>

         <div className="header-right">
            <div className="timer-info">
               <Clock size={10} />
               <span>{hoursLeft}h {minutesLeft}m to post</span>
            </div>
            <div className="streak-info">
               <span className="fire-emoji">🔥</span>
               <span>{currentUser.streak} day streak</span>
            </div>
            <div className="reward-info">
               <span className="gift-emoji">🎁</span>
               <span>{daysUntilReward} days to reward</span>
            </div>
         </div>
      </div>
   );
};

export default Header;